import { render, staticRenderFns } from "./AdministratorCreate.vue?vue&type=template&id=b028940e&"
import script from "./AdministratorCreate.vue?vue&type=script&lang=js&"
export * from "./AdministratorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports